<script>

	import Number from "./Number.svelte";
	import Summary from "./Summary.svelte";
	import Menu from "./Menu.svelte";
	import Availability from "./Availability.svelte";
	import Sushiboats from "./Sushiboats.svelte";
	import Form from "./Form.svelte";

	import { menu, step, index, nextstep, summary, order } from "./store.js";

	let formData = {
		first_name: '',
		last_name: '',
		email: '',
		phone: '',
		address: '',
		message: '',
	}

let selected = null;

function checkout()
{
	let details = $order;

	const detailsJSON = JSON.stringify(details);

	fetch(bookingConfig.url, {
		method: 'POST',
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded',
		},
		body: new URLSearchParams({
			action: 'booking_create_order',
			first_name: formData.first_name,
			last_name: formData.last_name,
			email: formData.email,
			phone: formData.phone,
			address: formData.address,
			message: formData.message,
			details: detailsJSON,
			date: [selected.year, selected.month, selected.date].join("-"),
			slot_from: selected.slot[0].join(" "),
			slot_to: selected.slot[1].join(" ")
		}),
	}).then(x=>x.json()).then(x => {

		const stripe = Stripe(bookingConfig.publishableKey);

		stripe.redirectToCheckout({ sessionId: x }).then(result => {
			if (result.error)
			{
				alert(result.error.message);
			}
		});

	});
}

</script>


<section class="py-16 px-4">

	<div class="flex flex-col items-center gap-5 container mx-auto">

		<h2 class="text-3xl lg:text-5xl font-semibold uppercase tracking-wide lg:leading-tight text-center">Place Order</h2>

		{#if $menu}
		<div class="flex flex-col gap-5 items-center bg-light w-full p-10">
			{#if $index == 0}
				<Availability bind:selected={selected} />
			{:else if $step == 'sushiboats'}
				<Sushiboats />
				<Summary />
			{:else if $menu[$step]}
				<Menu />
				<Summary />
			{:else}
				<Form bind:data={formData} />
			{/if}

			<div class="mt-5 bg-primary text-white flex items-center justify-between gap-8 w-full px-5 py-3">

				{#if $index > 0}
				<button class="border-0 bg-white text-dark px-4 py-2" on:click="{()=>$index--}">Back</button>
				{:else}
				<span></span>
				{/if}

				<div class="flex gap-8 justify-end items-center">
					<div class="flex gap-2">
						{#if summary}
							<span class="font-semibold">Total</span>
							<span class="italic">${$summary.total / 100}</span>
						{/if}
					</div>
					{#if selected}
					{#if $index == 5}
						{#if $summary.total > 0}
						<button class="border-0 bg-white text-dark px-4 py-2 capitalize" on:click="{checkout}">Checkout</button>
						{:else}
						order something first to checkout
						{/if}
					{:else if $index == 4}
						<button class="border-0 bg-white text-dark px-4 py-2 capitalize" on:click="{()=>$index++}">Provide Info</button>
					{:else}

						{#if $nextstep == 'sushiboats'}
							<button class="border-0 bg-white text-dark px-4 py-2 capitalize" on:click="{()=>$index+=2}">Skip Sushi Boats</button>
							<button class="border-0 bg-white text-dark px-4 py-2 capitalize" on:click="{()=>$index++}">Select Sushi Boats</button>
						{:else}
							<button class="border-0 bg-white text-dark px-4 py-2 capitalize" on:click="{()=>$index+=2}">Skip {$nextstep}</button>
							<button class="border-0 bg-white text-dark px-4 py-2 capitalize" on:click="{()=>$index++}">Select {$nextstep}</button>
						{/if}

					{/if}
					{/if}
				</div>
			</div>

		</div>
		{/if}
	</div>
</section>